module.exports = __webpack_public_path__ + "static/media/studentZFM.28dc0533.png";